import { render } from "./producer-attachment.vue?vue&type=template&id=3c586792"
import script from "./producer-attachment.vue?vue&type=script&lang=js"
export * from "./producer-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__